import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";
import { applyBrand } from "@/context/ConfigContext";
import SchoolSite from "@/pages/SchoolSite";
import PlatformHome from "@/pages/PlatformHome";
import SiteStatus from "@/components/site/SiteStatus";

// Root route: the backend decides from the hostname whether this is the platform or a school subdomain.
export default function HostHome() {
  const [site, setSite] = useState(null);

  useEffect(() => {
    axios.get(`${API}/site/resolve`, { params: { host: window.location.hostname } })
      .then(({ data }) => setSite(data))
      .catch(() => setSite({ kind: "error" }));
  }, []);

  useEffect(() => { if (site && site.kind !== "school") applyBrand(null); }, [site]);

  if (!site) return <div className="min-h-screen" />;
  if (site.kind === "school") return <SchoolSite slug={site.slug} school={site.school} />;
  if (site.kind === "platform") return <PlatformHome />;
  return <SiteStatus kind={site.kind} slug={site.slug} />;
}
